import { select, call, race, take, delay, put } from "redux-saga/effects";
import { statusSuccess, statusFailed, actions } from "@grandvisionhq/state";
import { LensPackageStepContainer } from "../../../../../../../../steps/LensPackageStep/steps/LensPackageStep/LensPackageStepContainer.js";
import "../../../../../../../state/actions.js";
import { loadMissingAddOns } from "../../../../../../../bundles/state/bundles/sagas.js";
import "../../../../../../../add-to-cart/state/add-to-cart/selectors.js";
import "../../../../../../../bundles/state/bundles/selectors.js";
import "../../../../../../../bundles/state/bundles/reducer.js";
import { getSelectedPackage, getFrameSku, getPackages, getSelectedLensType } from "../../../../../../state/configurator/selectors.js";
import "../../../../../../state/configurator/reducer.js";
import "../../../../../../../products/state/products/selectors.js";
import "../../../../../../../products/state/products/reducer.js";
import { selectPackage } from "../../../../../../../configurations/state/configurations/actions.js";
import { fetchPackagesSuccess, fetchPackagesFailed } from "../../../../../../../bundles/state/bundles/actions.js";
const lensPackageStepBase = {
  *onEnter() {
    yield call(selectDefaultPackage);
  },
  *onNext() {
    const selectedPackage = yield select(getSelectedPackage);
    if (!selectedPackage) {
      return new Error(`Selecting a lens-package is required`);
    }
  },
  view: LensPackageStepContainer
};
const isSuccess = ({ lensTypeSku }) => (a) => actions.isType(a, fetchPackagesSuccess) && a.payload.lensTypeSku === lensTypeSku;
const isFailed = ({ lensTypeSku }) => (a) => actions.isType(a, fetchPackagesFailed) && a.payload.lensTypeSku === lensTypeSku;
function* selectDefaultPackage() {
  const selectedPackage = yield select(
    getSelectedPackage
  );
  if (!selectedPackage) {
    const frameSku = yield select(getFrameSku);
    if (!frameSku) {
      return;
    }
    let packages = yield select(getPackages);
    if (!statusSuccess(packages) && !statusFailed(packages)) {
      const lensType = yield select(
        getSelectedLensType
      );
      if (!lensType) {
        return;
      }
      const [success] = yield race([
        take(isSuccess({ lensTypeSku: lensType.sku })),
        take(isFailed({ lensTypeSku: lensType.sku })),
        delay(3e4, true)
      ]);
      if (success) {
        packages = yield select(getPackages);
      }
    }
    if (statusSuccess(packages)) {
      let packageSku = packages.result[0]?.sku;
      for (const product of packages.result) {
        if (product.isDefault) {
          packageSku = product.sku;
          break;
        }
      }
      if (packageSku) {
        yield put(
          selectPackage({
            frameSku,
            packageSku,
            reason: "default selection"
          })
        );
      }
    }
  } else {
    yield call(loadMissingAddOns, selectedPackage.sku);
  }
}
export {
  lensPackageStepBase,
  selectDefaultPackage
};
//# sourceMappingURL=lens-package.js.map
